import React, { FC, useEffect, useRef } from 'react';
import { DefaultLayoutPadding } from '../../../constants/Layout';
import theme, { BorderColors } from '../../../theme';
import { FlexContainer } from '../Container';
import { Description, Error, Input, Label, InputTextArea } from './style';

export interface InputTextProps {
  borderColor?: BorderColors;
  name: string;
  label?: string;
  description?: string;
  autoFocus?: boolean;
  error?: string;
  icon?: React.ReactNode;
  type?: string;
  [x: string]: any;
}

const InputText: FC<InputTextProps> = ({
  icon,
  borderColor,
  error,
  name,
  label,
  description,
  autoFocus,
  type,
  ...otherProps
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    autoFocus && inputRef.current.focus();
  }, [autoFocus]);

  const InputComponent = type === 'textarea' ? InputTextArea : Input;

  return (
    <FlexContainer style={{ position: 'relative' }} flexDirection="column">
      {label && <Label htmlFor={name}>{label}</Label>}
      {description && <Description>{description}</Description>}
      <Error
        style={{
          position: 'absolute',
          top: label ? '20px' : '-20px',
          paddingLeft: theme.spacing[DefaultLayoutPadding],
        }}
      >
        {error}
      </Error>
      <InputComponent
        paddingLeft={icon && 'md'}
        borderColor={borderColor}
        error={error}
        name={name}
        type={type}
        {...otherProps}
        ref={inputRef}
      />
      {icon && (
        <FlexContainer
          align="center"
          style={{ maxWidth: '16px', height: '100%', position: 'absolute', top: '0%', left: '10px' }}
        >
          {icon}
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default InputText;
